/** Calculate byte size from a base64 string (data URI or raw). */
export function base64ToByteSize(base64String: string): number {
	const parts = base64String.split(',');
	const base64Data = parts.length > 1 ? (parts[1] ?? base64String) : base64String;
	let padding = 0;
	if (base64Data.endsWith('==')) {
		padding = 2;
	} else if (base64Data.endsWith('=')) {
		padding = 1;
	}
	return Math.ceil((base64Data.length * 3) / 4) - padding;
}

/** Read a browser File as a base64 data URL (`data:<mime>;base64,<...>`) via FileReader. Consumed by
 * the chats + market-maker frontends for attachment / photo uploads. */
export function fileToBase64(file: File): Promise<string> {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => {
			if (typeof reader.result === 'string') {
				resolve(reader.result);
			} else {
				reject(new Error('Failed to read file as base64'));
			}
		};
		reader.onerror = () => reject(new Error('FileReader error', { cause: reader.error }));
		reader.readAsDataURL(file);
	});
}
